<template>
	<div class="wrap">
		<Title :title="model.vacationName"></Title>
		<table class="table-column2">
			<tr>
				<th>活动名称</th>
				<td>{{model.vacationName}}</td>
			</tr>
			<!-- <tr>
				<th>活动logo</th>
				<td>
					<img :src="model.logoFileUrl"/>
				</td>
			</tr> -->
			<tr>
				<th>活动海报</th>
				<td>
					<img v-if="model.bannerFileUrl" :src="model.bannerFileUrl"/>
				</td>
			</tr>
			<tr>
				<th>宣传视频</th>
				<td>
					<video autoplay muted :src="model.videoFileUrl"></video>
				</td>
			</tr>
			<tr>
				<th>活动简介</th>
				<td><div v-html="model.content"></div></td>
			</tr>
			<tr>
				<th>发起方名称</th>
				<td>{{model.startCompayName}}</td>
			</tr>
			<tr>
				<th>赞助方Logo</th>
				<td>
					<img v-if="model.startLogo1FileUrl" :src="model.startLogo1FileUrl"/>
					<img v-if="model.startLogo2FileUrl" :src="model.startLogo2FileUrl"/>
					<img v-if="model.startLogo3FileUrl" :src="model.startLogo3FileUrl"/>
				</td>
			</tr>
			<tr>
				<th>招募时间</th>
				<td>{{model.recruitStartTime | datefmt2('YYYY-MM-DD HH:mm:ss')}} ~ {{model.recruitEndTime | datefmt2('YYYY-MM-DD HH:mm:ss')}}</td>
			</tr>
			<tr>
				<th>招募人数</th>
				<td>{{model.recruitNums}}</td>
			</tr>
			<tr>
				<th>抢席位名额</th>
				<td>{{model.cardNum}}</td>
			</tr>
			<tr>
				<th>招募范围</th>
				<td>
					<span v-if="model.recruitType==0">全国范围高校</span>
					<span v-if="model.recruitType==1">限定地区高校</span>
				</td>
			</tr>
			<tr>
				<th>联系人</th>
				<td>{{model.contactPerson}}</td>
			</tr>
			<tr>
				<th>联系电话</th>
				<td>{{model.contactPhone}}</td>
			</tr>
			<tr>
				<th>社会实践服务时长</th>
				<td>{{model.practiceHour}}小时</td>
			</tr>
			<tr>
				<th>活动类型</th>
				<td>
					<span v-if="model.activityType==0">包裹发放</span>
					<span v-if="model.activityType==1">最美推荐</span>
					<span v-if="model.activityType==0&&model.deliveryType==0">（现场领取）</span>
					<span v-if="model.activityType==0&&model.deliveryType==1">（邮寄配送）</span>
				</td>
			</tr>
			<tr v-if="model.activityType==0">
				<th>物资来源</th>
				<td>
					<span v-if="model.materialSources==0">平台采购</span>
					<span v-if="model.materialSources==1">自备包裹</span>
				</td>
			</tr>
			<tr v-if="model.activityType==0">
				<th>签收人数</th>
				<td>{{model.signNum}}</td>
			</tr>
			<tr v-if="model.activityType==0">
				<th>包裹价值（元）</th>
				<td>{{model.packPrice}}</td>
			</tr>
			<tr v-if="model.activityType==0">
				<th>给受助者物品	</th>
				<td><div v-html="model.goodsDetails"></div></td>
			</tr>
			<tr v-if="model.activityType==0">
				<th>给志愿者物品</th>
				<td v-html="model.volunteerItemDetails"></td>
			</tr>
		</table>
		<el-table size="mini" border :data="taskList" style="width: 100%">
			<el-table-column prop="taskName" label="任务名称">
			</el-table-column>
			<el-table-column label="任务内容" width="500">
				<template slot-scope="scope">
					<div v-html="scope.row.taskContent"></div>
				</template>
			</el-table-column>
			<el-table-column prop="coverFileUrl" label="任务图片">
				<template slot-scope="scope">
					<img v-if="scope.row.coverFileUrl" style="width: 130px; height: 130px;" :src="scope.row.coverFileUrl"/>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="activityType" label="活动类型">
				<template slot-scope="scope">
					<span v-if="scope.row.activityType=='1'">最美推荐</span>
					<span v-if="scope.row.activityType=='0'">包裹发放</span>
				</template>
			</el-table-column> -->
		</el-table>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam, config } from '@/units/request.js'
	import Title from '@/components/titleAdmin'
	export default {
		name: 'AdminActDetail',
		components: {
			Title
		},
		data() {
			return {
				activityId: '',
				model: {},
				taskList: [],
				pageSize: 10,
				pageNum: 1
			}
		},
		created() {
			this.activityId = this.$route.query.id
			this.getDetailData()
		},
		methods: {
			//获取活动详情
			async getDetailData() {
				let param = {
					id: this.activityId
				}
				ajaxParam(param)
				const res = await post('admin/vacation/detail', qs.stringify(param))
				this.model = res.data.entity
				this.getTaskList()
			},
			//获取任务列表
			async getTaskList() {
				let param = {
					vacationId: this.activityId,
					//activityType: this.model.activityType,
					pageSize: this.pageSize,
					pageNum: this.pageNum
				}
				ajaxParam(param)
				const res = await post('admin/task/list', qs.stringify(param))
				if (res.data.code == 200) {
					this.taskList = res.data.page.items
				}
			},
		}
	}
</script>

<style scoped lang="less">
	@import '../../table.less';
	.table-column2{
		margin-bottom: 20px;
		img{
			width: 130px;
			height: 130px;
		}
	}
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 10px;
	}
</style>